export default "__VITE_ASSET__57ab4984__"